import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import CommonTable from '../../CommonTable/CommonTable';
import FileList from './FileList';
import CustomPagination from '../../CustomPagination/CustomPagination';
import Loader from '../../Loader/Loader';

import DocumentManagement from './DocumentManagementQuery.graphql';
import showAllDocumentQuery from './showAllDocumentQueryFile.graphql'
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { withMutation, withQuery } from '../../../hoc/withGraphql';
import { censorEmail, decode } from '../../../helpers/secureEmail';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import s from './DocumentVerification.css';
import messages from '../../../locale/jsonMessages';
class DocumentVerification extends React.Component {

  static propTypes = {
    data: PropTypes.array,
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.state = {
      currentPage: 1,
      searchList: '',
      typing: false,
      typingTimeout: 0,
      isRestrict: false
    }
  }

  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode();
    this.setState({ isRestrict });
  }

  async handleUpdate(id, status, item, searchList) {
    const { mutate, currentPage } = this.props;
    const { data } = await mutate({
      variables: {
        userId: id,
        isIdVerification: Number(status)
      },
      refetchQueries: [{ query: showAllDocumentQuery, variables: { currentPage, searchList } }]
    });

    if (data?.DocumentManagement?.status === 'success') {
      let msg = 'Documents have been ';
      msg += (status == 1) ? 'Approved.' : 'Rejected.';
      showToaster({ messageId: 'commonSuccess', toasterType: 'success', requestMessage: msg })
    } else {
      showToaster({ messageId: 'documentManagementError', toasterType: 'error', requestMessage: data.DocumentManagement && data.DocumentManagement.errorMessage })
    }
  }

  paginationData = (currentPage) => {
    const { showAllDocument: { refetch }, setStateVariable } = this.props;
    let variables = { currentPage };
    setStateVariable(variables);
    refetch(variables);
  }

  handleClick = (searchList) => {
    const { showAllDocument: { refetch }, setStateVariable } = this.props;
    let variables = {
      currentPage: 1,
      searchList: searchList
    };
    this.setState(variables);
    setStateVariable(variables)
    refetch(variables);
  }

  handleSearchChange = (e) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleClick(self.state.searchList);
      }, 450)
    });
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.sNotoId) },
      { data: formatMessage(messages.userNameLabel) },
      { data: formatMessage(messages.userEmailLabel) },
      { data: formatMessage(messages.requestedFiles) },
      { data: formatMessage(messages.actionLabel) }
    ]
  };

  tbody = (props) => {
    const { showAllDocument: { showAllDocument }, currentPage } = props;
    const { formatMessage } = this.props.intl;
    const { searchList, isRestrict } = this.state;

    if (showAllDocument && showAllDocument.results && showAllDocument.results.length > 0) return showAllDocument.results?.map((value, key) => {
      return {
        id: value?.id,
        data: [
          { data: value?.profile?.profileId },
          {
            data: value?.profile?.firstName
          },
          { data: !isRestrict ? decode(value.encryptEmail) : censorEmail(decode(value.encryptEmail)) },
          { data: <FileList key={'f' + key} data={value.document} /> },
          {
            data: <div>
              <select className='commonTableInsideSelect' value={value.verification.isIdVerification} onChange={(e) => this.handleUpdate(value?.id, e?.target?.value, value, searchList)}>
                <option value={0}>{formatMessage(messages.messageStatus5)}</option>
                <option value={1}>{formatMessage(messages.approve)}</option>
                <option value={2}>{formatMessage(messages.documentReject)}</option>
              </select>
            </div>

          }
        ]
      }
    })
  }

  render() {

    const { formatMessage } = this.props.intl;
    const { showAllDocument: { loading, showAllDocument }, searchList, currentPage } = this.props;

    if (loading) {
      return <Loader type={"text"} />
    }

    return (
      <div>
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          title={formatMessage(messages.documentVerification)}
          isSearch
          onSearch={this.handleSearchChange}
        />
        {
          !loading && showAllDocument && showAllDocument.results && showAllDocument.results.length > 0
          && <div>
            <CustomPagination
              total={showAllDocument.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.usersLabel)}
            />
          </div>
        }
      </div>
    );
  }

}

const mapState = (state) => ({});

const mapDispatch = {
  demoRestrictionEncode
};


export default compose(injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
  withMutation(DocumentManagement,
    { options: { fetchPolicy: 'network-only' } }),
  withQuery(showAllDocumentQuery, {
    name: 'showAllDocument',
    options: (props) => ({

      fetchPolicy: 'network-only',
      variables: {
        currentPage: 1,
        searchList: '',
        ssr: false
      },
    })
  }),)(DocumentVerification);